<template>
    <div id="lessonCancelledNotification">
        <template v-for="lesson in cancelledLessons">
            <p v-if="lesson.player" :key="lesson.id">
                <strong>{{ lesson.player.first_name }} {{ lesson.player.last_name }} </strong>has
                cancelled their {{ lesson.duration }} minute lesson on
                <strong>{{ $date(lesson.date).format("DD MMMM YYYY") }}</strong> at
                {{ $date(lesson.date).format("HH:mm") }}.
            </p>
        </template>

        <p>Would you like to notify the rest of your players about this availability?</p>

        <button
            :disabled="form.busy"
            class="button dark half"
            @click.prevent="updateCancelledLesson(true)"
        >
            {{ form.busy && form.response ? "Please wait..." : "Yes" }}
        </button>
        <button
            :disabled="form.busy"
            class="button red half"
            @click.prevent="updateCancelledLesson(false)"
        >
            {{ form.busy && !form.response ? "Please wait..." : "No" }}
        </button>
    </div>
</template>

<script>
import { Form } from "vform";
export default {
    name: "",
    props: {
        cancelledLessons: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            form: new Form({
                response: "",
            }),
        };
    },
    methods: {
        updateCancelledLesson(response) {
            this.form.response = response;
            if (this.form.response) {
                this.$notify("A notification has been sent to your players");
            } else {
                this.$notify("We won't notify your players about this");
            }
            this.$emit("dismissed");
            this.form.post("/lesson_cancelled").then((response) => {
                console.log(response);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#lessonCancelledNotification {
    padding: 20px;
    border-radius: 12px;
    background: #eff5f2;
    margin-bottom: 20px;
    color: #267962;
    line-height: 1.5;
    p {
        margin-bottom: 20px;
        strong {
            font-weight: bold;
        }
    }
}
</style>
